/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import React from 'react';
import { Button, Nav, NavItem, NavItemProps } from 'reactstrap';
import './styles.scss';

interface MenuItemProps extends Pick<NavItemProps, 'onClick' | 'active' | 'label'> {
  hidden?: boolean;
  disabled?: boolean;
}

export interface MenuProps {
  grouped?: boolean;
  items: MenuItemProps[];
  color?: 'primary' | 'secondary';
  className?: string;
}

export const Menu = (props: MenuProps) => {
  const {
    color = 'primary',
    grouped,
    className = 'mb-2',
    items
  } = props;

  return (
    <Nav fill={!grouped} className={`menu-component menu-component-${grouped ? 'grouped' : 'spaced'} ${className}`}>
      {items.map((item, i) => {
        return !item.hidden ? (
          <NavItem key={`${i}-${item.label}`}>
            <Button
              color={item.active ? 'primary' : color}
              className={grouped ? '' : 'w-100'}
              size={grouped ? 'sm' : 'md'}
              disabled={item.disabled}
              onClick={item.disabled || item.active ? undefined : item.onClick}
              active={item.active}
              outline={!item.active}
            >
              {item.label}
            </Button>
          </NavItem>
        ) : null;
      })}
    </Nav>
  );
}
